const getRoute = (route, params) => {
  switch (route) {
    case "home-page":
      return { href: "/", as: "/" };

    case "login":
      return {
        href: "/login",
        as: `${params?.session ? `/login?=${params?.session}` : `/login`}`
      };

    case "register":
      return { href: "/register", as: "/register" };

    case "reset-password":
      return { href: "/reset-password", as: "/reset-password" };

    case "contact":
      return { href: "/contact", as: "/contact" };

    case "delivery":
      return { href: "/delivery", as: "/delivery" };

    case "payment":
      return {
        href: "/payment",
        as: `${params?.query ? `/payment?${params?.query}` : `/payment`}`
      };

    case "returns":
      return { href: "/returns", as: "/returns" };

    case "terms-conditions":
      return { href: "/terms-conditions", as: "/terms-conditions" };

    case "about-us":
      return { href: "/about-us", as: "/about-us" };

    case "our-promise":
      return { href: "/our-promise", as: "/our-promise" };

    case "privacy-policy":
      return { href: "/privacy-policy", as: "/privacy-policy" };

    case "about-cookies":
      return { href: "/about-cookies", as: "/about-cookies" };

    case "product-page":
      return { href: "/[...categoryOrProductPage]", as: `/${params.url}` };

    case "hit-product-page":
      return { href: "/hot-deal", as: `/hot-deal` };

    case "catalogsearch":
      return {
        href: "/catalogsearch/result/[...query]",
        as: `/catalogsearch/result/${params.query}`
      };

    case "cart":
      return { href: "/cart", as: "/cart" };

    case "category-page":
      return { href: "/[...categoryOrProductPage]", as: `/${params.url}` };

    case "article":
      return { href: "/article/[article]", as: `/${params.url}` };

    case "info":
      return { href: "/info/[info]", as: `${params.url}` };

    case "info/rules":
      return { href: "/info/[info]", as: `/info/rules` };

    case "checkout-payment":
      return { href: "/checkout/payment", as: "/checkout/payment" };

    case "checkout":
      return { href: "/checkout", as: "/checkout" };

    case "account":
      return { href: "/account", as: "/account" };

    case "account-order":
      return {
        href: "/account/orders/[id]",
        as: `/account/orders/${params.id}?page=${params.page}${
          params.type ? `&type=${params.type}` : ""
        }`
      };

    case "account-orders":
      return {
        href: "/account/orders",
        as: "/account/orders"
      };

    case "account-info":
      return {
        href: "/account/personal-info",
        as: "/account/personal-info"
      };

    case "account-address":
      return {
        href: "/account/address-book/[id]",
        as: `/account/address-book/${params}`
      };

    case "account-address-book":
      return {
        href: "/account/address-book",
        as: `/account/address-book`
      };

    case "account-epoints-info":
      return {
        href: "/account/epoints-info/[page]",
        as: `/account/epoints-info/${params.page}`
      };

    case "churchill":
      return { href: "/churchill", as: "/churchill" };

    case "ariane":
      return { href: "/ariane", as: "/ariane" };

    case "sola":
      return { href: "/sola", as: "/sola" };

    case "alchemy":
      return { href: "/alchemy", as: "/alchemy" };

    case "ambition":
      return { href: "/ambition", as: "/ambition" };

    case "pasabahce":
      return { href: "/pasabahce", as: "/pasabahce" };

    case "newsletter-signup":
      return { href: "/newsletter/signup", as: "/newsletter/signup" };

    case "newsletter-signoff":
      return { href: "/newsletter/signoff", as: "/newsletter/signoff" };

    case "inspirations":
      return { href: "/inspirations", as: "/inspirations" };

    case "promotions":
      return { href: "/promotions", as: "/promotions" };

    default:
      return { href: route, as: route };
  }
};

export default getRoute;
